/** ------------------------------------------------------------------------- *
 * Content Animations *
 * -------------------------------------------------------------------------- *
 * @module Animate
 * @desc
 * TODO: Module description
 */

const settings = {
    // The default DOMString selector for initializing the module
    selector: '[class*=js-animate]',
    // The class to be added to loaded elements
    state_class: 'is-animated',
    // Options for the intersection observer
    observer: {
        // null = document root
        root: null,
        // Extend the bounding box of the intersecting element by 40vh
        rootMargin: '0px 0px -25% 0px',
        // 0 = the element is not in view
        threshold: 0,
    },
};

/**
 * @property animateElement
 * @param {Element} el - The HTML element to load
 * @desc Adds a class to initiate the animation
 */

function animateElement(el) {
    el.classList.add(settings.state_class);
}

/**
 * @property observer
 * @desc
 * An intersection observer is used to determine when an element is in view and
 * should be animated in.
 */

const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            animateElement(entry.target);

            // Remove from observation once animated
            observer.unobserve(entry.target);
        }
    });
}, settings.observer);

/** ------------ *
 * Module Export *
 * ------------- *
 */

const Animate = {
    /**
     * @property Animate.selector
     * @desc The default DOMString selector for initializing the module
     */

    selector: settings.selector,

    /**
     * @property Animate.init
     * @method
     * @param {String} [selector] - The DOMString selector for the element(s) to load
     * @desc Initializes the animation observer
     */

    init(selector = settings.selector) {
        const elements = document.querySelectorAll(selector);
        const el_arr = Array.from(elements);

        el_arr.forEach((el) => {
            observer.observe(el);
        });
    },
};

export default Animate;
